import { render, staticRenderFns } from "./IconPayment.vue?vue&type=template&id=23b1cb44"
import script from "./IconPayment.vue?vue&type=script&lang=js"
export * from "./IconPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports